import { BackArrow } from "components/icons/back-arrow-primary/back-arrow-primary";
import { UserPreferencesHeading } from "components/atoms/update-account/user-preferences-heading";
import { UpdateAccountForm } from "components/molecules/update-account/update-account-form";
import { ProfilePageContainer } from "components/templates/page-template/page-template-for-profile";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "store";
import { useDispatch } from "react-redux";
import { setLoader } from "reducers/uiSlice";
import { Notification } from '../../components/molecules/loader/loader';
import { PageTemplate } from "components/templates/page-template/page-template";

export const AccountUpdate: React.FC = () => {
  const loader = useAppSelector((state) => state.ui.loader);
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (loader?.status) {
      setLoading(true);
      setTimeout(() =>{
        dispatch(setLoader({status: '', message: ""}))
      }, 1000)
    } else {
      setLoading(false);
    }
  }, [loader]);

  return (
    <PageTemplate>
      <div className="flex">
      {isLoading && <Notification status={loader.status} message={loader.message}/>}
        <BackArrow />
        <UserPreferencesHeading heading="Account" />
      </div>
      <div>
          <UpdateAccountForm />
        </div>
    </PageTemplate>
  );
};
